import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import API_CONFIG from '@/api/config'
import { Select, Option } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false
Vue.use(Select)
Vue.use(Option)

const toSafeHeaderValue = (value) => {
  const str = String(value ?? '')
  for (let i = 0; i < str.length; i += 1) {
    if (str.charCodeAt(i) > 255) {
      return encodeURIComponent(str)
    }
  }
  return str
}

axios.interceptors.request.use(
  (config) => {
    const requestUrl = `${config.baseURL || ''}${config.url || ''}`
    if (requestUrl.includes('/qianchuan/info/api')) {
      const cardNumber = toSafeHeaderValue(localStorage.getItem('cardNumber') || '')
      if (config.headers && typeof config.headers.set === 'function') {
        config.headers.set('cardNumber', cardNumber)
      } else {
        config.headers = {
          ...(config.headers || {}),
          cardNumber
        }
      }
    }
    return config
  },
  (error) => Promise.reject(error)
)

let heartbeatTimer = null
let logoutInProgress = false
const HEARTBEAT_INTERVAL_MS = 30000
const HEARTBEAT_API_PATH = '/card/card/api/token'
const CLOSE_TOOLS_API_PATH = '/api/tools/close-all'

const clearAuthStorage = () => {
  localStorage.removeItem('authToken')
  localStorage.removeItem('cardNumber')
  localStorage.removeItem('remainDays')
  localStorage.removeItem('remainAuthorizedCount')
}

const stopHeartbeat = () => {
  if (heartbeatTimer) {
    clearInterval(heartbeatTimer)
    heartbeatTimer = null
  }
}

const closeOpenedToolsOnLogout = async () => {
  try {
    await axios.post(CLOSE_TOOLS_API_PATH, {})
  } catch (error) {
    console.warn('关闭本地工具失败:', error?.message || error)
  }
}

const HEARTBEAT_PAGE_NAMES = new Set([
  'LicenseCheck',
  'HomePage',
  'AuthorizationPage',
  'UploadVideo',
  'VideoShare',
  'WalletManagement',
  'DataOverview'
])

const isHeartbeatPage = (vm) => {
  return !!(vm && vm.$options && HEARTBEAT_PAGE_NAMES.has(vm.$options.name))
}

const forceLogout = async () => {
  if (logoutInProgress) {
    return
  }
  logoutInProgress = true
  await closeOpenedToolsOnLogout()
  clearAuthStorage()
  stopHeartbeat()
  try {
    if (router.currentRoute.path !== '/') {
      alert('登录已过期，请重新登录')
      await router.replace('/')
    }
  } finally {
    logoutInProgress = false
  }
}

const getAuthToken = () => String(localStorage.getItem('authToken') || '')

const heartbeatCheck = async () => {
  const token = getAuthToken()
  if (!token) {
    return
  }
  try {
    const response = await axios.get(API_CONFIG.getFullUrl(HEARTBEAT_API_PATH), {
      params: {
        token
      }
    })
    if (Number(response?.data?.code) === 500) {
      await forceLogout()
    }
  } catch (error) {
    // 心跳请求失败时不立即退出，避免网络抖动误判
    console.warn('心跳检测失败:', error?.message || error)
  }
}

const startHeartbeat = () => {
  if (heartbeatTimer) {
    return
  }
  heartbeatTimer = setInterval(() => {
    heartbeatCheck()
  }, HEARTBEAT_INTERVAL_MS)
  heartbeatCheck()
}

document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible' && getAuthToken()) {
    heartbeatCheck()
  }
})

Vue.mixin({
  mounted() {
    if (!isHeartbeatPage(this)) {
      return
    }
    if (this.__heartbeatTimer) {
      clearInterval(this.__heartbeatTimer)
    }
    heartbeatCheck()
    this.__heartbeatTimer = setInterval(() => {
      heartbeatCheck()
    }, HEARTBEAT_INTERVAL_MS)
  },
  beforeDestroy() {
    if (this.__heartbeatTimer) {
      clearInterval(this.__heartbeatTimer)
      this.__heartbeatTimer = null
    }
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

startHeartbeat()
